import { Info } from "lucide-react";
import { DEMO_NOTE } from "@/config/company";

export default function DemoNote({ className = "" }) {
  return (
    <p
      data-testid="demo-note"
      className={`inline-flex max-w-3xl items-start gap-2 border border-white/10 bg-white/[0.02] px-4 py-3 font-tech text-[10px] leading-relaxed tracking-wider text-white/40 ${className}`}
    >
      <Info className="mt-0.5 size-3.5 shrink-0 text-molten" />
      {DEMO_NOTE}
    </p>
  );
}
